import { Injectable } from '@angular/core';
import { FatherService } from './father.service';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from './localstorage.service';
import { OrganizationInterface } from '../interfaces/organization.interface';
import { Observable, of } from 'rxjs';
import { OrganizationDetailsInterface } from '../interfaces/organization-details.interface';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService extends FatherService{

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  createOrganization(data: OrganizationInterface) {
    return this.post('/api-license/organization', data)
  }

  loadOrganizationList(): Observable<OrganizationInterface[]> {
    return this.get('/api-license/organization') || of([])
  }

  deleteOrganization(id: number): Observable<any> {
    return this.delete(`/api-license/organization/${id}`);
  }


  //Временно не работает, нужно делать интеграцию через дженкинс
  updateServerOrganization(ipAddress: string){
    return this.post(`/api-license/organization/update-organization-server`, {ipAddress: ipAddress})
      .subscribe((res) => {
        console.log('res', res);
      })

  }

  getOrganizationDetails(id: number): Observable<OrganizationDetailsInterface> {
    return this.get(`/api-license/organization/${id}`);
  }
}
